export default function Tooltip({ content, children, className }) {
    return (
        <div className={`tooltip w-full ${className}`} data-tip={content}>
            {children}
        </div>
    );
}
